export default "__VITE_ASSET__C1TPY5G8__"